module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style7/message-alert-style7.component.scss
// module id = ./src/app/features/message-alert/message-alert-style7/message-alert-style7.component.scss
// module chunks = main